import { Chip } from '@mui/material';
import { BooleanField, FunctionField, Link, useTranslate } from 'react-admin';

import { B2bCcbConfig } from '@Common/types/bo/b2b/plans';
import { GetInstrumentsResponseItem } from '@Common/types/bo/instruments';

import { ShowFields, ShowSection } from '@sh4res/bo-common/components';
import { buildLink } from '@sh4res/bo-common/utils/build_link';

const prefix = 'resources.bo_common.b2b.companies.saving_plans.sections.general';
const testId = 'BoExternalB2bPlansCcbSection';

export const CcbSection = ({
  ccbConfig,
}: {
  ccbConfig: B2bCcbConfig & { instruments: GetInstrumentsResponseItem[] };
}) => {
  const translate = useTranslate();

  return (
    <ShowSection label={`${prefix}.ccb_parameters`} noCard={true}>
      <ShowFields<
        Record<
          | 'ccb_instruments_universe'
          | 'ccb_option_at_maturity'
          | 'ccb_is_arbitrage_allowed_into_per'
          | 'ccb_payer_of_liquidity'
          | 'ccb_handover_date',
          unknown
        >
      >
        labelPrefix={prefix}
        borderBottom={false}
        fields={{
          ccb_instruments_universe: (
            <FunctionField
              label="Name"
              render={() =>
                ccbConfig.instruments.map((instrument) => (
                  <Link
                    to={buildLink('instruments', 'show', instrument.id)}
                    sx={{
                      margin: '2px !important',
                    }}>
                    <Chip label={instrument.name || instrument.symbol} />
                  </Link>
                ))
              }
              data-testid={`${testId}_InstrumentsUniverseField`}
            />
          ),
          ccb_option_at_maturity: (
            <FunctionField
              render={() =>
                translate(`${prefix}.ccb_option_at_maturity_${ccbConfig.option_at_maturity}`)
              }
              data-testid={`${testId}_OptionAtMaturityField`}
            />
          ),
          ccb_is_arbitrage_allowed_into_per:
            ccbConfig.option_at_maturity === 'consultation' ? (
              <BooleanField
                record={{
                  ccb_is_arbitrage_allowed_into_per: ccbConfig.is_arbitrage_allowed_into_per,
                }}
                data-testid={`${testId}_IsArbitrageAllowedIntoPer`}
              />
            ) : undefined,
          ccb_payer_of_liquidity: (
            <FunctionField
              render={() =>
                translate(`${prefix}.ccb_payer_of_liquidity_${ccbConfig.payer_of_liquidity}`)
              }
              data-testid={`${testId}_PayerOfLiquidityField`}
            />
          ),
          ccb_handover_date: (
            <FunctionField
              render={() => ccbConfig.handover_date}
              data-testid={`${testId}_HandoverDateField`}
            />
          ),
        }}
      />
    </ShowSection>
  );
};
